<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div class="template-creator">
    <div :class="['overlay', {active: isLoading}]">
      <loading-spinner
        custom-id="template-creator-loader"
        :loading-status="isLoading"
      />
    </div>
    <div class="row mt-4 my-4">
      <div class="col-12 d-flex">
        <div
          class="p-2 flex-grow-1"
        >
          <h1 class="main-header">
            Create Template
          </h1>
          <h2 class="sub-header">
            Pick your preferred editor to unleash your creativity and craft visually stunning emails.
          </h2>
        </div>
        <div
          class="p-2 align-self-center"
        >
          <button
            id="btnCancel"
            class="btn btn-lg btn-outline-secondary px-4 white ml-3"
            style="font-weight: 600;"
            @click="onCancel"
          >
            Cancel
          </button>
        </div>
      </div>
      <div class="col-12 mt-4">
        <div class="d-flex">
          <div v-show="studioEditorPermission"
               class="col template-card"
          >
            <svg width="100" height="82" viewBox="0 0 100 82" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2.48853" y="1.5" width="95.023" height="79" rx="7.5" fill="white" stroke="#12263F" stroke-width="3" />
              <mask id="path-2-inside-1_6248_112269" fill="white">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.98853 0C5.01796 0 0.988525 4.02944 0.988525 9V22H99.0115V9C99.0115 4.02944 94.9821 0 90.0115 0H9.98853Z" />
              </mask>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.98853 0C5.01796 0 0.988525 4.02944 0.988525 9V22H99.0115V9C99.0115 4.02944 94.9821 0 90.0115 0H9.98853Z" fill="#E9F1FA" />
              <path d="M0.988525 22H-2.01147V25H0.988525V22ZM99.0115 22V25H102.012V22H99.0115ZM3.98853 9C3.98853 5.68629 6.67482 3 9.98853 3V-3C3.36111 -3 -2.01147 2.37258 -2.01147 9H3.98853ZM3.98853 22V9H-2.01147V22H3.98853ZM0.988525 25H99.0115V19H0.988525V25ZM96.0115 9V22H102.012V9H96.0115ZM90.0115 3C93.3252 3 96.0115 5.68629 96.0115 9H102.012C102.012 2.37258 96.6389 -3 90.0115 -3V3ZM9.98853 3H90.0115V-3H9.98853V3Z" fill="#12263F" mask="url(#path-2-inside-1_6248_112269)" />
              <circle cx="73.4885" cy="11.5" r="2.5" fill="#12263F" />
              <circle cx="81.4885" cy="11.5" r="2.5" fill="#12263F" />
              <circle cx="89.4885" cy="11.5" r="2.5" fill="#12263F" />
              <path d="M15.1572 40.971L19.2457 37.2228C19.7664 36.7451 19.8018 35.9361 19.3242 35.415C18.8465 34.8938 18.0375 34.8589 17.5164 35.3365L12.3988 40.0277C12.3847 40.0405 12.3749 40.0558 12.3617 40.069C12.3485 40.0822 12.3331 40.0921 12.3203 40.1061C12.3033 40.1245 12.2922 40.1458 12.2764 40.1646C12.2482 40.1995 12.2214 40.2341 12.1971 40.2707C12.1745 40.3057 12.1544 40.3407 12.1352 40.3769C12.1156 40.4149 12.0968 40.4524 12.0811 40.4921C12.0653 40.5305 12.0525 40.5693 12.041 40.6085C12.0295 40.6477 12.0192 40.687 12.0111 40.7271C12.003 40.7676 11.9979 40.8081 11.9941 40.8495C11.9911 40.89 11.9885 40.9301 11.9885 40.971C11.9885 41.0119 11.9911 41.052 11.9949 41.0925C11.9988 41.1335 12.0039 41.174 12.012 41.2149C12.0201 41.255 12.0299 41.2943 12.0418 41.3335C12.0533 41.3727 12.0661 41.4115 12.0819 41.4499C12.0977 41.4892 12.1165 41.5271 12.1361 41.5651C12.1553 41.6009 12.1753 41.6363 12.1979 41.6713C12.2222 41.7079 12.2491 41.7425 12.2772 41.7775C12.293 41.7962 12.3041 41.8175 12.3212 41.8359C12.3335 41.8491 12.348 41.8585 12.3608 41.8709C12.3745 41.8849 12.3851 41.9011 12.3996 41.9144L17.5172 46.6055C17.7625 46.8302 18.0721 46.9415 18.3808 46.9415C18.7271 46.9415 19.0721 46.8017 19.3242 46.5266C19.8018 46.0055 19.7664 45.1964 19.2457 44.7188L15.1572 40.971Z" fill="#276ECD" />
              <path d="M42.6797 40.8495C42.6754 40.8081 42.6707 40.7676 42.6626 40.7262C42.6545 40.6866 42.6447 40.6482 42.6336 40.6094C42.6217 40.5689 42.608 40.5296 42.5923 40.4904C42.5769 40.4524 42.559 40.4153 42.5398 40.3786C42.5202 40.3415 42.4993 40.3053 42.4763 40.2699C42.4532 40.2345 42.4268 40.2004 42.3991 40.1667C42.3829 40.1471 42.3713 40.1253 42.3543 40.1066C42.3411 40.0921 42.3257 40.0823 42.3116 40.0686C42.2988 40.0558 42.289 40.0405 42.2754 40.0281L37.1578 35.3369C36.6366 34.8593 35.8276 34.8951 35.35 35.4154C34.8728 35.9366 34.9082 36.7456 35.4289 37.2232L39.5174 40.971L35.4284 44.7192C34.9077 45.1969 34.8723 46.0059 35.3496 46.527C35.602 46.8017 35.947 46.9416 36.2933 46.9416C36.6021 46.9416 36.9117 46.8302 37.1573 46.6051L42.275 41.9139C42.289 41.9007 42.2997 41.8849 42.3129 41.8713C42.3257 41.8585 42.3411 41.8491 42.3539 41.8355C42.3709 41.8167 42.3824 41.7949 42.3986 41.7753C42.4259 41.7416 42.4524 41.7075 42.4758 41.6721C42.4993 41.6367 42.5202 41.6005 42.5394 41.5634C42.5586 41.5267 42.5765 41.4896 42.5918 41.4516C42.6076 41.4124 42.6208 41.3727 42.6332 41.3327C42.6443 41.2938 42.6545 41.2555 42.6622 41.2158C42.6703 41.1749 42.675 41.1343 42.6792 41.0926C42.6831 41.052 42.6856 41.012 42.6856 40.971C42.6856 40.9301 42.6831 40.89 42.6797 40.8495Z" fill="#276ECD" />
              <path d="M36.293 40.9711C36.293 40.2644 35.7202 39.6917 35.0136 39.6917H19.6607C18.9541 39.6917 18.3813 40.2644 18.3813 40.9711C18.3813 41.6777 18.9541 42.2505 19.6607 42.2505H35.0136C35.7202 42.2505 36.293 41.6773 36.293 40.9711Z" fill="#276ECD" />
              <path d="M19.3242 52.4741C18.8465 51.953 18.0375 51.918 17.5164 52.3952L12.3988 57.0864C12.3847 57.0992 12.3745 57.115 12.3608 57.129C12.348 57.1418 12.3327 57.1516 12.3203 57.1653C12.3037 57.1832 12.2926 57.2041 12.2772 57.2228C12.2487 57.2578 12.2214 57.2932 12.1966 57.3307C12.174 57.3649 12.1544 57.3998 12.1352 57.4357C12.1152 57.4736 12.0968 57.5116 12.0811 57.5512C12.0653 57.5896 12.0529 57.6284 12.041 57.6672C12.0295 57.7069 12.0188 57.7461 12.0111 57.7862C12.003 57.8267 11.9979 57.8668 11.9941 57.9082C11.9911 57.9487 11.9885 57.9888 11.9885 58.0297C11.9885 58.0707 11.9911 58.1108 11.9949 58.1513C11.9988 58.1926 12.0039 58.2327 12.012 58.2732C12.0197 58.3138 12.0299 58.353 12.0418 58.3922C12.0533 58.4315 12.0661 58.4703 12.0819 58.5082C12.0977 58.5479 12.1165 58.5858 12.1361 58.6238C12.1548 58.6596 12.1749 58.6946 12.1975 58.7287C12.2222 58.7662 12.2491 58.8016 12.2777 58.8366C12.293 58.8554 12.3045 58.8763 12.3207 58.8942C12.3327 58.907 12.3476 58.9163 12.3596 58.9287C12.3736 58.9428 12.3843 58.959 12.3992 58.9731L17.5168 63.6642C17.7625 63.889 18.0721 64.0003 18.3808 64.0003C18.7271 64.0003 19.0721 63.8608 19.3242 63.5853C19.8018 63.0642 19.7664 62.2552 19.2457 61.7775L15.1572 58.0297L19.2457 54.2819C19.7669 53.8043 19.8018 52.9948 19.3242 52.4741Z" fill="#276ECD" />
              <path d="M42.6797 57.9083C42.6758 57.8669 42.6707 57.8268 42.6626 57.7854C42.6545 57.7458 42.6447 57.707 42.6336 57.6686C42.6217 57.6285 42.6085 57.5888 42.5923 57.55C42.5769 57.5116 42.559 57.4745 42.5394 57.4374C42.5202 57.4008 42.4997 57.3645 42.4767 57.3295C42.4528 57.2933 42.4264 57.2587 42.3982 57.2246C42.3824 57.2054 42.3713 57.1837 42.3539 57.1653C42.3411 57.1513 42.3257 57.1415 42.3121 57.1282C42.2984 57.115 42.289 57.0997 42.275 57.0865L37.1573 52.3953C36.6362 51.9185 35.8272 51.9531 35.3496 52.4742C34.8723 52.9954 34.9077 53.8044 35.4284 54.282L39.517 58.0298L35.4284 61.7776C34.9077 62.2552 34.8723 63.0647 35.3496 63.5854C35.602 63.8609 35.947 64.0003 36.2933 64.0003C36.6021 64.0003 36.9117 63.889 37.1573 63.6643L42.275 58.9731C42.2895 58.9599 42.3001 58.9437 42.3138 58.9296C42.3266 58.9169 42.3415 58.9075 42.3539 58.8942C42.3709 58.8755 42.382 58.8542 42.3982 58.835C42.4259 58.8009 42.4528 58.7663 42.4767 58.7301C42.5001 58.6951 42.5206 58.6588 42.5394 58.6222C42.559 58.5851 42.5769 58.548 42.5923 58.5096C42.6085 58.4703 42.6212 58.4307 42.6336 58.391C42.6447 58.3518 42.6549 58.3134 42.6626 58.2742C42.6707 58.2328 42.6758 58.1927 42.6797 58.1513C42.6835 58.1104 42.6861 58.0707 42.6861 58.0298C42.6861 57.9889 42.6831 57.9492 42.6797 57.9083Z" fill="#276ECD" />
              <path d="M36.293 58.0296C36.293 57.323 35.7203 56.7502 35.0136 56.7502H26.9107C26.2041 56.7502 25.6313 57.323 25.6313 58.0296C25.6313 58.7363 26.2041 59.309 26.9107 59.309H35.0136C35.7203 59.309 36.293 58.7363 36.293 58.0296Z" fill="#276ECD" />
              <path d="M25.6419 52.1363C24.9779 51.8953 24.2435 52.2369 24.0021 52.9014L20.5904 62.2837C20.349 62.9481 20.6915 63.6816 21.3555 63.9234C21.4996 63.9759 21.6476 64.0011 21.7926 64.0011C22.3155 64.0011 22.8059 63.6782 22.9948 63.1584L26.4066 53.7761C26.6488 53.1116 26.3063 52.3777 25.6419 52.1363Z" fill="#276ECD" />
              <line x1="51.4885" y1="21" x2="51.4885" y2="79" stroke="#12263F" stroke-width="3" />
              <rect x="63.9885" y="34" width="22" height="33" rx="1" stroke="#12263F" stroke-width="3" />
            </svg>

            <h2 class="editor-name">
              Studio Editor
            </h2>
            <h3 class="editor-detail">
              Coding optional, advanced personalization
            </h3>
            <h3 class="editor-description">
              Create customized email templates tailored to your specific needs with this flexible drag-and-drop and code editor.
            </h3>
            <router-link
              :to="{name: 'TemplateCreator', query: $route.query }"
              style="text-decoration: none;"
            >
              <button class="create-template-button">
                Start Building
              </button>
            </router-link>
          </div>
          <div v-show="dragAndDropPermission" class="col template-card">
            <svg width="100" height="82" viewBox="0 0 100 82" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2.48853" y="1.5" width="95.023" height="79" rx="7.5" fill="white" stroke="#12263F" stroke-width="3" />
              <mask id="path-2-inside-1_6248_112302" fill="white">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.98853 0C5.01796 0 0.988525 4.02944 0.988525 9V22H99.0115V9C99.0115 4.02944 94.9821 0 90.0115 0H9.98853Z" />
              </mask>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.98853 0C5.01796 0 0.988525 4.02944 0.988525 9V22H99.0115V9C99.0115 4.02944 94.9821 0 90.0115 0H9.98853Z" fill="#E9F1FA" />
              <path d="M0.988525 22H-2.01147V25H0.988525V22ZM99.0115 22V25H102.012V22H99.0115ZM3.98853 9C3.98853 5.68629 6.67482 3 9.98853 3V-3C3.36111 -3 -2.01147 2.37258 -2.01147 9H3.98853ZM3.98853 22V9H-2.01147V22H3.98853ZM0.988525 25H99.0115V19H0.988525V25ZM96.0115 9V22H102.012V9H96.0115ZM90.0115 3C93.3252 3 96.0115 5.68629 96.0115 9H102.012C102.012 2.37258 96.6389 -3 90.0115 -3V3ZM9.98853 3H90.0115V-3H9.98853V3Z" fill="#12263F" mask="url(#path-2-inside-1_6248_112302)" />
              <circle cx="73.4885" cy="11.5" r="2.5" fill="#12263F" />
              <circle cx="81.4885" cy="11.5" r="2.5" fill="#12263F" />
              <circle cx="89.4885" cy="11.5" r="2.5" fill="#12263F" />
              <rect x="18.9885" y="33" width="42" height="30" rx="2" stroke="#12263F" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="4 6" />
              <rect x="44.9885" y="44" width="39" height="24" rx="2" fill="white" stroke="#276ECD" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
              <rect width="17.5569" height="20.0716" transform="translate(68.9885 51)" fill="white" />
              <path d="M82.991 57.6919L72.4741 54.1374C71.5484 53.8245 70.5961 54.6071 70.7597 55.5458L72.6199 66.2115C72.7836 67.1505 73.9409 67.5413 74.703 66.9155L77.1268 64.3L80.2052 67.8369C80.5536 68.2345 81.0537 68.4789 81.5963 68.5167C82.139 68.5546 82.6801 68.3828 83.1017 68.0388C83.5211 67.6922 83.7856 67.2024 83.8375 66.6763C83.8895 66.1502 83.7247 65.6305 83.3791 65.2305L80.3007 61.6936L83.3585 59.8062C84.121 59.1785 83.9168 58.0049 82.991 57.6919Z" fill="#276ECD" />
            </svg>

            <h2 class="editor-name">
              Classic Drag-and-Drop
            </h2>
            <h3 class="editor-detail">
              No coding required
            </h3>
            <h3 class="editor-description">
              Need a quick marketing email with minimal personalization in your email?  Effortlessly create stunning designs in this easy-to-use drag-and-drop editor.
            </h3>
            <router-link
              :to="{name: 'TemplateCreatorDragAndDrop', query: $route.query }"
              style="text-decoration: none;"
            >
              <button class="create-template-button">
                Start Building
              </button>
            </router-link>
          </div>
          <div v-show="customCodePermission"
               class="col template-card"
          >
            <svg width="100" height="82" viewBox="0 0 100 82" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_6248_112328)">
                <rect x="2" y="1.5" width="95.023" height="79" rx="7.5" fill="white" stroke="#12263F" stroke-width="3" />
                <line x1="0.5" y1="20.5" x2="98.5" y2="20.5" stroke="#12263F" stroke-width="3" />
                <mask id="path-3-inside-1_6248_112328" fill="white">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 0C4.52944 0 0.5 4.02944 0.5 9V22H98.523V9C98.523 4.02944 94.4936 0 89.523 0H9.5Z" />
                </mask>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 0C4.52944 0 0.5 4.02944 0.5 9V22H98.523V9C98.523 4.02944 94.4936 0 89.523 0H9.5Z" fill="#E9F1FA" />
                <path d="M0.5 22H-2.5V25H0.5V22ZM98.523 22V25H101.523V22H98.523ZM3.5 9C3.5 5.68629 6.18629 3 9.5 3V-3C2.87258 -3 -2.5 2.37258 -2.5 9H3.5ZM3.5 22V9H-2.5V22H3.5ZM0.5 25H98.523V19H0.5V25ZM95.523 9V22H101.523V9H95.523ZM89.523 3C92.8367 3 95.523 5.68629 95.523 9H101.523C101.523 2.37258 96.1504 -3 89.523 -3V3ZM9.5 3H89.523V-3H9.5V3Z" fill="#12263F" mask="url(#path-3-inside-1_6248_112328)" />
                <path d="M55.375 35.5625L47.375 63.5625C47.0625 64.625 46 65.25 44.9375 64.9375C43.875 64.625 43.25 63.5625 43.5625 62.5L51.5625 34.5C51.875 33.4375 52.9375 32.8125 54 33.125C55.0625 33.4375 55.6875 34.5 55.375 35.5625ZM61.875 40.625L68.875 47.625C69.6875 48.375 69.6875 49.6875 68.875 50.4375L61.875 57.4375C61.125 58.25 59.8125 58.25 59.0625 57.4375C58.25 56.6875 58.25 55.375 59.0625 54.625L64.625 49L59.0625 43.4375C58.25 42.6875 58.25 41.375 59.0625 40.625C59.8125 39.8125 61.125 39.8125 61.875 40.625ZM39.875 43.4375L34.3125 49L39.875 54.625C40.6875 55.375 40.6875 56.6875 39.875 57.4375C39.125 58.25 37.8125 58.25 37.0625 57.4375L30.0625 50.4375C29.25 49.6875 29.25 48.375 30.0625 47.625L37.0625 40.625C37.8125 39.8125 39.125 39.8125 39.875 40.625C40.6875 41.375 40.6875 42.6875 39.875 43.4375Z" fill="#276ECD" />
                <circle cx="73" cy="11.5" r="2.5" fill="#12263F" />
                <circle cx="81" cy="11.5" r="2.5" fill="#12263F" />
                <circle cx="89" cy="11.5" r="2.5" fill="#12263F" />
              </g>
              <defs>
                <clipPath id="clip0_6248_112328">
                  <rect width="99" height="82" fill="white" transform="translate(0.5)" />
                </clipPath>
              </defs>
            </svg>
            <h2 class="editor-name">
              Custom Code
            </h2>
            <h3 class="editor-detail">
              Full code control, advanced personalization
            </h3>
            <h3 class="editor-description">
              Take full control over your template with our advanced code editor to impress your recipients with professionally crafted campaigns.
            </h3>
            <router-link
              :to="{name: 'TemplateCreatorCustomCode', query: $route.query }"
              style="text-decoration: none;"
            >
              <button class="create-template-button">
                Start Building
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div v-if="alertKind === 'success'">
      <Alert
        v-model="alertKind"
        :icon="['far', 'info-circle']"
        :timeout="15"
      >
        Template saved successfully
      </Alert>
    </div>
    <div v-if="alertKind === 'danger'">
      <Alert
        v-model="alertKind"
        :icon="['far', 'info-circle']"
        :timeout="5"
      >
        An error has occurred while processing your request. Please contact <a href="mailto:producthelp@cendyn.com">producthelp@cendyn.com</a> for assistance.
      </Alert>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner'
import Alert from '@/components/Alert'
import { mapGetters, mapState } from 'vuex'

export default {
  components: {
    LoadingSpinner,
    Alert
  },
  data () {
    return {
      alertKind: ''
    }
  },
  computed: {
    ...mapState({
      studioEditorPermission: state => state.templateBuilder.studioEditorCreatePermission,
      dragAndDropPermission: state => state.templateBuilder.dragAndDropCreatePermission,
      customCodePermission: state => state.templateBuilder.customCodeCreatePermission
    }),
    ...mapGetters({
      isLoading: 'getLoadingStatus'
    })
  },
  methods: {
    onCancel () {
      this.$store.commit('SET_TEMPLATE_ON_EDITION', null)
      const query = Object.assign({}, this.$route.query)
      delete query.isGlobal
      this.$router.push({ name: 'TemplateBuilder', query })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../node_modules/@syncfusion/ej2-base/styles/bootstrap4.css';
  @import '../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap4.css';
  @import '../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap4.css';

  .template-creator {
    position: relative;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    display: none;
    background-color: #ffffffcf;
    &.active {
      display: block;
    }
  }

  a#SendToTestEmails {
    &:hover {
      text-decoration: none;
    }
  }

  .divider {
    border-bottom: 1px solid $gray-light;
  }

  .e-float-input input, .e-float-input.e-control-wrapper input, .e-float-input textarea, .e-float-input.e-control-wrapper textarea {
    border-radius: 2px;
  }
  .e-btn-primary {
    border-radius: 2px;
    color: $white;
    background-color: $bocalipstick;
    border-color: $bocalipstick-dark;
  }
  .description textarea {
    height: 100px;
  }

  .main-header{
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 28px;
    color: #1C1C1C;
  }

  .sub-header{
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #666666;
  }

  .template-card{
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 32px;
    background: #FFFFFF;
    border: 1px solid #CCCCCC;
    border-radius: 2px;
    margin:10px;
  }
  .editor-name{
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    text-align: center;
    color: #1C1C1C;
    margin-top: 2rem;
  }

  .editor-description{
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #666666;
    max-width: 30rem;
    margin-top: 1rem;
  }

  .editor-detail{
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #999999;
  }

  .create-template-button{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 16px;
    background: #D63A67;
    border: 1px solid #D63A67;
    border-radius: 2px;
    color: white;
    height: 4rem;
    margin-top: 2rem;
  }

</style>
